export const NEW_ORDERS_COLUMNS_OPTIONS = [
  {
    label:
      'Ver os chamados que foram recém abertos e os chamados que necessitam de seleção de um prestador na mesma coluna.',
    option: 'new_orders',
  },
  {
    label:
      'Dividir a visualização em chamados recém abertos e chamados que necessitam da seleção de um prestador.',
    option: 'triage+allocate_provider',
  },
]

export const NEGOTIATE_BUDGET_COLUMNS_OPTIONS = [
  {
    label: 'Ver os orçamentos emitidos e pendentes de aprovação todos juntos numa única etapa.',
    option: 'negotiate_budget',
  },
  {
    label: 'Dividir em orçamentos para enviar e orçamentos aguardando aprovação.',
    option: 'review_and_send_budget+waiting_payer_approval',
  },
  {
    label:
      'Dividir em orçamentos para revisar antes de enviar, orçamentos para enviar após revisão e orçamentos aguardando aprovação.',
    option: 'review_budget+send_budget_to_payer+waiting_payer_approval',
  },
]

export const WAITING_BUDGET_COLUMNS_OPTIONS = [
  {
    label:
      'Ver os chamados que necessitam agendamento de orçamento e os chamados com orçamento já agendado na mesma coluna.',
    option: 'waiting_budget',
  },
  {
    label:
      'Dividir a visualização em chamados que necessitam agendamento de orçamento e chamados com orçamento já agendado.',
    option: 'budget_scheduling+in_budget',
  },
]

export const WAITING_EXECUTION_COLUMNS_OPTIONS = [
  {
    label:
      'Ver os chamados que necessitam agendamento de execução, os que estão com execução já agendada e os chamados com serviço já executado na mesma coluna.',
    option: 'waiting_execution',
  },
  {
    label:
      'Dividir a visualização em chamados em agendamento de execução, em execução (execução agendada) e os já executados (que só precisam finalizar).',
    option: 'execution_scheduling+in_execution+executed',
  },
]

export const HELP_RESOURCES_SLUGS = {
  newOrders: 'kanban_split_columns_new_orders',
  negotiateBudget: 'kanban_split_columns_negotiate_budget',
  waitingBudget: 'kanban_split_columns_waiting_budget',
  waitingExecution: 'kanban_split_columns_waiting_execution',
}
